module.exports = __webpack_public_path__ + "img/profile-user.ac42e6a6.png";